import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  signal,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Estimate, VendorOrder } from '../../../../../../shared/models/vendor-order.model';
import { QuoteCardComponent } from '../quote-card/quote-card.component';

@Component({
  selector: 'app-previous-quotes',
  imports: [MatIcon, QuoteCardComponent],
  templateUrl: './previous-quotes.component.html',
  styleUrl: './previous-quotes.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviousQuotesComponent {
  readonly estimates = input.required<Estimate[]>();
  readonly order = input.required<VendorOrder>();
  readonly lowestCostId = input<string | null>(null);

  readonly isExpanded = signal(false);

  readonly isLowestRate = (estimate: Estimate): boolean => {
    const id = estimate.vendorId ?? estimate.estimationsId ?? null;
    if (!id) return false;
    return id === this.lowestCostId();
  };

  toggleSection(): void {
    this.isExpanded.update(v => !v);
  }
}
